"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var countup_js_1 = require("countup.js");
var handleStatistics = function () {
    var statisticsItems = document.getElementsByClassName("statistics__statistics-item-counter");
    var countUps = [];
    for (var i_1 = 0; i_1 < statisticsItems.length; i_1++) {
        var statItem = statisticsItems[i_1];
        countUps[i_1] = new countup_js_1.CountUp("statistic-counter-".concat(i_1), parseFloat(statItem.dataset.endValue), {
            startVal: parseFloat(statItem.dataset.startValue),
            duration: 5,
            decimalPlaces: parseInt(statItem.dataset.decimalPlaces),
            separator: statItem.dataset.separator,
            decimal: statItem.dataset.decimal,
            prefix: statItem.dataset.prefix,
            suffix: statItem.dataset.suffix,
            // enableScrollSpy: true,
            // scrollSpyOnce: true,
            // scrollSpyDelay: 3000,
        });
    }
    if (countUps.length > 0) {
        var observer_1 = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    setTimeout(function () {
                        countUps.forEach(function (countUp) { return countUp.start(); });
                    }, 1000);
                    observer_1.unobserve(entry.target);
                }
            });
        });
        countUps.forEach(function (countUp) { return observer_1.observe(countUp.el); });
    }
};
document.addEventListener('DOMContentLoaded', function () {
    handleStatistics();
});
